const isMigratedToCdn = (url) => !!url && url.replace('https://', '').split('.')[0] === 'cdn';

module.exports = (env) => {
    env.addFilter('format_currency', (value, currency = 'EUR', attrs = [], locale = undefined) => {
        locale = locale ?? document.documentElement.dataset.icuLocale;

        const num = parseFloat(value);
        return num.toLocaleString(locale, {
            style: 'currency',
            currency: currency
        });
    });

    env.addFilter('convertToFiveScaleRating', (value) => {
        if (value === null) {
            return null;
        }

        return Math.ceil((value / 2) * 10) / 10;
    });

    env.addFilter('merge', (arr, newArr) => {
        if (Array.isArray(newArr)) {
            return [...arr, ...newArr];
        }

        const key = Object.keys(newArr)[0];
        const value = Object.values(newArr)[0];
        arr[key] = value;
        return arr;
    });

    env.addFilter('split', function (str, delimiter) {
        return str.split(delimiter);
    });

    env.addFilter('formatImageUrl', (url, width, height) => {
        if (!url) {
            return url;
        }

        if (isMigratedToCdn(url)) {
            return `${url}&aspect_ratio=${width}:${height}&width=${width}&height=${height}`;
        }

        return `${url},fit=cover,width=${width},height=${height}`;
    });

    env.addFilter('raw', (value) => value);

    env.addFilter('json_encode', (value) => JSON.stringify(value));

    env.addFilter('format_number', (value, attrs = [], locale = undefined) => {
        locale = locale ?? document.documentElement.dataset.icuLocale;

        return Number(value).toLocaleString(locale, {
            minimumFractionDigits: attrs['min_fraction_digit'] ?? 0,
            maximumFractionDigits: attrs['max_fraction_digit'] ?? 2
        });
    });
};
